require('lie/polyfill')
require('babel-polyfill')
var hyperdom = require('hyperdom')
var router = require('./router')

var root = require('./rootComponent')(window.lexemeData)
hyperdom.append(document.body, root, {router: router})
